var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card show_more"},[_c('div',{staticClass:"wrap flx",on:{"click":_vm.addProducts}},[_c('span',{staticClass:"download_ico_arrows"}),_c('span',{staticClass:"text"},[_vm._v("Показать еще "+_vm._s(_vm.perPage)+" товаров")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }